export default {
  admin: {
    superAdminGroup: 'adminPeaceLove',
    adminGroup: 'admin',
    hostGroup: 'host'
  },
  metrics: {
    adminTenantId: 'adminPeaceLoveMetrics'
  },
  domain: {
    http: import.meta.env.VITE_GRAPHQL_API_URL_HTTP,
    ws: import.meta.env.VITE_GRAPHQL_API_URL_WS
  },
  resourceDomain: `resources.${import.meta.env.VITE_APP_URL}`,
  siteDomain: import.meta.env.VITE_APP_URL,
  aws: {
    cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
      identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID
    }
  },
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
  rollbar: {
    accessToken: import.meta.env.VITE_ROLLBAR_CLIENT_TOKEN ?? '',
    environment: import.meta.env.VITE_APP_ENV ?? 'development',
    enabled: Boolean(import.meta.env.VITE_ROLLBAR_CLIENT_TOKEN ?? '')
  }
};
